import { Fragment, useState } from "react";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { OutlinedInput, Typography, useTheme } from "@mui/material";
import TableSort from "./table-sort";
import { SortDirEnum } from "@/services/dropdown-enums";

export default function TableHeader({
  columns = [],
  onSort,
  showFilters = false,
  filterValues = {},
  onFilterChange = () => {},
}) {
  const [sortInfo, setSortInfo] = useState(null);
  const { palette } = useTheme();

  const getSortType = (colName = "") => {
    const { ASC, DESC } = SortDirEnum;
    if (sortInfo?.colName == colName) {
      switch (sortInfo?.dir) {
        case "":
          return ASC;
        case ASC:
          return DESC;
        case DESC:
          return "";
        default:
          return null;
      }
    } else {
      return ASC;
    }
  };

  const onSortClick = (colName = "") => {
    let sortValue = getSortType(colName);
    let sort = {
      colName: colName,
      name: colName,
      dir: sortValue,
    };

    setSortInfo(sortValue ? sort : null);

    if (onSort) {
      onSort(sortValue ? sort : null);
    }
  };

  return (
    <TableHead sx={{ zIndex: 100, position: "relative" }}>
      <TableRow
        sx={
          {
            // "& .MuiTableCell-head:first-of-type": { borderRadius: "5px 0 0 0 " },
            // "& .MuiTableCell-head:last-of-type": { borderRadius: "0 5px 0 0" },
          }
        }
      >
        {columns.map((col, index) => (
          <Fragment key={index}>
            <TableCell
              align={col?.align}
              sx={{
                // backgroundColor: palette.base[60],
                backgroundColor: palette.custom.grid_header,
                borderColor: palette.custom.stroke,
                color: palette.base[100],
                fontWeight: 500,
                py: 1,
                px: "5px",
                ...(col?.sx || {}),
                width: col?.width || "auto",
                minWidth: col?.minWidth || col?.width || "auto",
              }}
            >
              <Typography
                onClick={
                  col?.sortable ? () => onSortClick(col.name) : undefined
                }
                sx={{
                  color: palette.custom.heading,
                  fontWeight: 500,
                  display: "flex",
                  width: "100%",
                  alignItems: "center",
                  cursor: col?.sortable ? "pointer" : "default",
                  userSelect: col?.sortable ? "none" : "auto",
                  justifyContent:
                    col?.align === "right"
                      ? "flex-end"
                      : col?.align === "center"
                        ? "center"
                        : "flex-start",
                }}
              >
                {col?.title}
                {col?.sortable && (
                  <TableSort
                    column={col}
                    onSortClick={onSortClick}
                    sortInfo={sortInfo}
                  />
                )}
              </Typography>
            </TableCell>
          </Fragment>
        ))}
      </TableRow>
      {showFilters && (
        <TableRow>
          {columns.map((col, index) => (
            <TableCell
              key={`filter-${index}`}
              align={col?.align}
              sx={{
                position: "sticky",
                top: "40px",
                zIndex: 1,
                backgroundColor: palette.custom.grid_header,
                borderColor: palette.custom.stroke,
                py: 0.75,
                px: "5px",
                width: col?.width || "auto",
                minWidth: col?.minWidth || col?.width || "auto",
                ...(col?.sx || {}),
              }}
            >
              {col?.filterable ? (
                <OutlinedInput
                  size="small"
                  value={filterValues[col.name] || ""}
                  onChange={(e) => onFilterChange(col.name, e.target.value)}
                  placeholder={col.placeholder || col.title || ""}
                  sx={{
                    width: "100%",
                    height: 32,
                    fontSize: "0.8125rem",
                    bgcolor: "var(--palette-container)",
                    color: "var(--palette-text)",
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "var(--palette-stroke)",
                    },
                    "& input::placeholder": {
                      color: "var(--palette-grey_text)",
                      opacity: 1,
                    },
                  }}
                />
              ) : null}
            </TableCell>
          ))}
        </TableRow>
      )}
    </TableHead>
  );
}
